export default Object.freeze({
  MANDIBULAIRE: 'MANDIBULAIRE',
  MAXIMILLAIRE: 'MAXIMILLAIRE',
  COMPLETE: 'COMPLETE',
});
